// ChatBox/styled.js
import styled from 'styled-components';

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 800px;
  max-height: 40dvh;
  background:rgb(196, 241, 227);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1000;

  @media (max-width: 600px) {
    width: 95%;
    max-height: 62dvh;
  }
`;

export const MainContainer = styled.div`
  width: 90dvh;
  height: 70dvh;
  max-width: 900px;
  margin: 0 auto;
  padding: 0;
  
  @media (max-width: 768px) {
    padding: 0;
    height: 10vh;
    margin: 0;
    max-width: 100%;
    position: fixed;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--jk-bg);
  gap: 20px;
  
  @media (max-width: 768px) {
    height: 90vh;
    gap: 0;
  }
`;

export const TopVisualContainer = styled.div`
  width: 100%;
  background: #fff;
  border: 2px solid var(--jk-white);
  border-radius: 16px;
  padding: 12px;
  display: flex;
  align-items: top;
  justify-content: center;
  min-height: 8dvh;

  @media (max-width: 768px) {
    min-height: 160px;
    padding: 8px;
    align-items: center;
  }
`;

export const TopVisualImage = styled.img`
  width: 100%;
  height: 35svh;
  object-fit: cover;
  border-radius: 12px;

  @media (max-width: 768px) {
    height: 100%;
`;

export const TitleBar = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: 18px;
  color: var(--jk-text);
  padding: 0 4px;
`;

export const ChatHeader = styled.div`
  //background: var(--jk-primary);
  background:#7ab7a5;
  color: #fff;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 10px;
`;

export const ChatAvatar = styled.div``;

export const ChatTitle = styled.div`
  flex: 1;
  display: none;
`;

export const ChatMessages = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px;
`;

export const ChatInputContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 4;
  display: flex;
  gap: 8px;
  padding: 10px;
  padding-bottom: calc(max(10px, env(safe-area-inset-bottom)) + var(--kb-offset, 0px));
  background: #fff;
  border-top: 1px solid var(--jk-muted);
`;

export const ChatTextarea = styled.textarea`
  flex: 1;
  padding: 8px;
  border: 1px solid var(--jk-muted);
  border-radius: 12px;
  margin-right: 10px;
  resize: none;
  min-height: 40px;
`;

export const ChatButton = styled.button`
  background: var(--jk-secondary);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  touch-action: manipulation;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    filter: brightness(0.95);
    transform: scale(1.05);
  }
  
  &:active {
     transform: scale(0.95);
  }
`;

export const AudioButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const AudioButton = styled.button`
  background: ${({ isRecording }) => isRecording ? 'var(--jk-error)' : 'var(--jk-primary)'};
  color: white;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  touch-action: manipulation;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  
  &:hover {
    filter: brightness(0.95);
    transform: scale(1.05);
  }
  
  &:disabled {
    background: var(--jk-muted);
    cursor: not-allowed;
    transform: none;
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const ProgressContainer = styled.div`
  position: absolute;
  bottom: 60px;
  left: 10px;
  right: 10px;
  background: rgba(38, 50, 56, 0.85);
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: var(--jk-bg);
  border-radius: 2px;
  overflow: hidden;
  
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${({ progress }) => progress}%;
    background: var(--jk-secondary);
    transition: width 0.3s ease;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Message = styled.div`
  align-self: ${({ isUser }) => (isUser ? 'flex-end' : 'flex-start')};
  background: ${({ isUser }) => (isUser ? 'var(--jk-yellow)' : '#fff')};
  color: var(--jk-text);
  padding: 8px 12px;
  border-radius: 16px;
  max-width: 80%;
  word-wrap: break-word;
  margin-bottom: 5px;
`;

